import * as React from "react";
import { useCallback } from "react";
import SortableList from "components/common/SortableList";
import StepListItem from "./StepListItem";
const renderStepListItem = ({
  onViewStep,
  onRemoveStep
}) => ({ item, dragHandle, className, ref }) => /* @__PURE__ */ React.createElement(
  StepListItem,
  {
    item,
    onViewStep,
    onRemoveStep,
    dragHandle,
    className,
    ref
  }
);
function StepList({ steps, onMoveList, onViewStep, onRemoveStep }) {
  const handleMoveList = useCallback((newList) => onMoveList(newList), [onMoveList]);
  return /* @__PURE__ */ React.createElement(
    SortableList,
    {
      items: steps,
      onMoveItem: handleMoveList,
      customListItemRender: renderStepListItem({ steps, onViewStep, onRemoveStep }),
      fullWidth: true
    }
  );
}
export default StepList;
